import React from 'react';

import StyledModalRoot from './styled/ModalRoot';
import { MODAL_ROOT_ID } from './constants';

const ModalRoot: React.FC = () => <StyledModalRoot id={MODAL_ROOT_ID} />;

export default ModalRoot;
